import { StoreSchema } from '../../types/store'
import { createSelector } from 'reselect'

export const selectProductsIsLoading = (store: StoreSchema) =>
    store.products.isLoading

export const selectProductsProductLoading = (store: StoreSchema) =>
    store.products.productLoading

export const selectProducts = (store: StoreSchema) => store.products.products

export const selectOneProduct = (guid: string) =>
    createSelector([selectProducts], (products) =>
        products.find((product) => product.guid === guid)
    )

export const selectProductsGroups = (store: StoreSchema) =>
    store.products.productsGroups

export const selectQuickAccess = (store: StoreSchema) =>
    store.products.quickAccess

export const selectIsProductRouted = (store: StoreSchema) => store.products.isProductRouted

export const selectProductsIdDisplayNameDict = (store: StoreSchema) =>
    store.products.productsIdDisplayNameDictionary

export const selectProductsIdTypeDict = (store: StoreSchema) =>
    store.products.productsIdTypeDictionary

export const selectProductType = (guid: string) =>
    createSelector([selectProductsIdTypeDict], (idTypeDict) => idTypeDict[guid])
